$(document).ready(function(){
  // Initially hide sections
  $('#get-in-touch-section').hide();
  $('#our-story-section').hide();
  let local = localStorage.getItem("seterpage");
  if(!local){
    localStorage.setItem("seterpage", "our-story");
  }
  // Event handler for "Get in Touch" click
  $("#get-in-touch").click(function(){
    localStorage.setItem("seterpage", "get-in-touch");
    // Update active class
    $("#our-story").removeClass("active");
    $("#get-in-touch").addClass("active");

    // Show/hide sections
    $('#get-in-touch-section').show();
    $('#our-story-section').hide();
  });

  // Event handler for "Our Story" click
  $("#our-story").click(function(){
    localStorage.setItem("seterpage", "our-story");
    // Update active class
    $("#our-story").addClass("active");
    $("#get-in-touch").removeClass("active");

    // Show/hide sections
    $('#get-in-touch-section').hide();
    $('#our-story-section').show();
  });

  // Retrieve the stored page from localStorage
  var x = localStorage.getItem("seterpage");

  // Handle the stored page on page load
  if(x == "get-in-touch"){
    $("#our-story").removeClass("active");
    $("#get-in-touch").addClass("active");

    $('#get-in-touch-section').show();
    $('#our-story-section').hide();
  }
  else if(x == "our-story"){
    $("#our-story").addClass("active");
    $("#get-in-touch").removeClass("active");

    $('#get-in-touch-section').hide();
    $('#our-story-section').show();
  }
  // Add similar conditions for "meet-team" if needed
});

$(document).ready(function() {

  // Define a function for background image parallax effect
  var background_image_parallax = function($object, multiplier) {
      // Set default multiplier if not provided
      multiplier = typeof multiplier !== 'undefined' ? multiplier : 0.5;
      multiplier = 1 - multiplier;
      var $doc = $(document);

      // Set the background-attachment to fixed
      $object.css({"background-attachment": "fixed"});

      // Handle the scroll event
      $(window).scroll(function() {
          if ($(window).width() < 760) {
              var from_top = $doc.scrollTop();
              var bg_css = ((multiplier * -from_top) + 100) + 'px';
              $object.css({"margin-top": bg_css});
          } else {
              var from_top = $doc.scrollTop();
              var bg_css = ((multiplier * -from_top) - 50) + 'px';
              $object.css({"margin-top": bg_css});
          }
      });
  };

  // Call the background_image_parallax function with the specified element and multiplier
  background_image_parallax($(".our-story-animation-box"), 0.85);

});
$(document).ready(function() {
  // Define a function for background image parallax effect
  var background_image_parallax = function($object, multiplier) {
      // Set default multiplier if not provided
      multiplier = typeof multiplier !== 'undefined' ? multiplier : 0.5;
      multiplier = 1 - multiplier;
      var $doc = $(document);

      // Set the background-attachment to fixed
      $object.css({"background-attachment": "fixed"});

      // Handle the scroll event
      $(window).scroll(function() {
          var from_top = $doc.scrollTop();
          var bg_css = '0px ' + ((multiplier * from_top) - 200) + 'px';
          $object.css({"background-position": bg_css});
      });
  };

  // Call the background_image_parallax function with the specified element and multiplier
  background_image_parallax($(".prellex-css-about-page"), 0.80);
});
